import React from 'react';
import Chart from '../components/Chart'
import AutoComplete from '../components/AutoComplete';

const Lead = (props) => {
    var sorted = props.testdata.sort(function(a,b) {
        return b.reports - a.reports
    }).slice(0,10);

  return (<div>
      <div className="white-box lead">
          <h1>Lead paint residue</h1>
          <div className="detailsection">
              <p>Lead is a toxic metal that can cause permanent neurotoxic damage when absorbed by the body. Until 1978, It was used extensively in residential paints in the United States.</p>
              <p>Young children, whose brains and bodies are rapidly developing, are most susceptible. Even small amounts of lead, if inhaled or ingested, can reduce IQ and trigger such behavioral problems as attention deficit disorder and impulsivity.</p>
              <p>Children can get lead poisoning by eating paint chips, putting their hands in their mouths after touching lead dust, breathing in lead dust, drinking water tainted by lead, or playing in soil contaminated by lead. Tests can determine the amount of lead currently in a child&rsquo;s bloodstream, but some damage can be irreversible.</p>
              <p>Children in Philadelphia are at particularly high risk for lead poisoning because most homes here were built before the 1978 lead-paint ban. Unlike with homes and apartments, currently no federal regulations ensure that schools are tested for lead and made safe.</p>
              <p>With more than 80 percent of district-run schools operating in buildings built before 1978, the district&rsquo;s duty to maintain painted surfaces is extremely high. The district does not routinely test painted surfaces for lead and is not required to do so. In most cases, district workers assume that paint in pre-1978 buildings contains lead.</p>
              <p>According to internal maintenance and environmental records reviewed by reporters, flaking and peeling paint was flagged for clean-up in nine out of 10 schools over the past three years.</p>
              <p>District staff and contractors are trained to remediate damaged lead paint and plaster, but struggle to maintain the nearly 250 pre-1978 buildings (average age 70 years). For concerns about lead paint and plaster damage contact the school district&rsquo;s <a href="https://www.philasd.org/capitalprograms/programsservices/environmental/environmental-programs-services/">Department of Environmental Programs</a> &amp; Services at 215-400-4730.</p>
              <hr/>
              <h3>Schools with highest number of damaged paint and plaster locations</h3>
              <Chart newdata={sorted} charttype="lead" chartlabel="Number of reports"/>
               </div>
      </div>

      {/* <hr />
      <div className="detailsection">


      </div> */}

      <div id="inputwrapper">
          <AutoComplete getUrl={props.match} data={props.data} placeholder="Search for another school..." />
      </div>
  </div>

  );
}

export default Lead;



// WEBPACK FOOTER //
// ./src/routes/Lead.js